import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      toast.error("Token não recebido do Google");
      navigate("/login");
      return;
    }
    localStorage.setItem("nia_token", token);
    api.get("/auth/me").then(({ data }) => {
      login(token, data);
      toast.success("Login realizado com sucesso");
      navigate(data.role === "super_admin" ? "/admin/sectors" : "/coordinator/documents");
    }).catch(() => {
      toast.error("Falha ao carregar perfil");
      navigate("/login");
    });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-10 h-10 text-[#1e5a8e] animate-spin" />
        <p className="text-sm text-slate-600">Autenticando…</p>
      </div>
    </div>
  );
}
